/* eslint-disable */
import React from 'react';
import {
    TextField,
    Datagrid,
    ReferenceField,
    Filter,
    TextInput,
    ReferenceInput,
    AutocompleteInput,
    useRecordContext,
    useRedirect,
    useStore,
    Button
} from 'react-admin';
import { ReadOnlyContext } from '../../lib/context/ReadOnlyContext';
import { SwList } from '../../lib/SwList';
import { useAzureADGroups } from '../../msal/useAzureADGroups';
import { CloneButton } from '../../lib/wrappers/actions';

export const CourseLinkField = ({ label, source }) => {
    const redirect = useRedirect();
    const record = useRecordContext();

    const [_, setCourseListParams] = useStore('Course.listParams');

    if (record && record[source]) {
        const onClick = (e) => {
            e.stopPropagation();

            setCourseListParams({
                displayedFilters: {},
                filter: { q: record[source] },
            });

            redirect('list', 'Course');
        };
        return <Button  variant="outlined" onClick={onClick} label={label} />;
    }
    return null;
};

const ModuleList = (props) => {
    const { canEditCourseAndModule } = useAzureADGroups();

    return (
        <ReadOnlyContext.Provider value={!canEditCourseAndModule}>
            <SwList {...props} filters={<ModuleFilter />}>
                <Datagrid
                    rowClick="edit"
                    bulkActionButtons={
                        !canEditCourseAndModule ? false : undefined
                    }
                >
                    <TextField source="shortTitle" label="Module Title" />
                    <TextField source="moduleCode" />
                    <TextField source="id" />
                    <ReferenceField
                        label="Credit Value"
                        reference="CreditValue"
                        source="creditValueId"
                        link={false}
                        >
                        <TextField source="creditvalue" />
                    </ReferenceField>
                    <ReferenceField
                        label="Credit Level"
                        reference="CreditLevel"
                        source="creditLevelId"
                        link={false}
                        >
                        <TextField source="Title" />
                    </ReferenceField>
                    <ReferenceField
                        label="Status"
                        reference="Status"
                        source="statusId"
                        link={false}
                        >
                        <TextField source="Title" />
                    </ReferenceField>
                    <CourseLinkField label="Courses" source="id" />
                    <CloneButton label="myroot.copy" />
                </Datagrid>
            </SwList>
        </ReadOnlyContext.Provider>
    );
};

const ModuleFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Search" source="q" alwaysOn />
        <TextInput label="Title" source="shortTitle" />
        <TextInput source="moduleCode" />
        <ReferenceInput label="Faculty" reference="Faculty" source="facultyId">
            <AutocompleteInput optionText="description" />
        </ReferenceInput>
    </Filter>
);

export default ModuleList;
